import { ActorFilterRegistryCategory } from '../ActorFilterRegistryCategory';
import { ActorFilterRegistryItem } from '../ActorFilterRegistryItem';
export class ActorFilterTag extends ActorFilterRegistryCategory {
    label = 'Tag';
    constructor(parent) {
        super(parent);
        const actors = ['questionpart', 'question'];
        const types = ['text', 'image', 'box', 'sound', 'video', 'table', 'gap'];
        const allTags = [];
        for (const actor of actors) {
            for (const type of types) {
                for (let i = 1; i <= 3; i++) {
                    allTags.push(`${actor}-${type}-${i}`);
                }
            }
        }
        allTags.forEach(tag => {
            this[tag] = () => new ActorFilterRegistryItem({ label: tag, filter: ({ a }) => a.tags.includes(tag) });
        });
        super.init();
    }
    byRoleIncludes = () => new ActorFilterRegistryItem({
        label: 'Ist getagged mit',
        filter: ({ a, trait }) => {
            const roleName = trait.local.valueOf.actorRoleName;
            return a.tags.includes(roleName);
        },
        params: { core: ['actorRoleName'] },
    });
    byRoleIncludesPartial = () => new ActorFilterRegistryItem({
        label: 'Tag enthält',
        filter: ({ a, trait }) => {
            const roleName = trait.local.valueOf.actorRoleName;
            return !!a.tags.find(tag => tag.includes(roleName));
        },
        params: { core: ['actorRoleName'] },
    });
    byRoleIncludesPattern = () => new ActorFilterRegistryItem({
        label: 'Ist getagged mit *-Muster (Beginn,MitteEnthält,Ende)',
        filter: ({ a, trait }) => {
            const roleName = trait.local.valueOf.actorRoleName;
            const parts = roleName.split('*');
            return !!a.tags.find(tag => {
                if (!tag.startsWith(parts[0]))
                    return false;
                if (!tag.endsWith(parts[parts.length - 1]))
                    return false;
                for (const part of parts) {
                    if (!tag.includes(part))
                        return false;
                }
                return true;
            });
        },
        params: { core: ['actorRoleName'] },
    });
}
